import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from "react";
import MESSAGES from "./Components/hooks/message";
type GameContextType = {
  message: string;
  setMessage: React.Dispatch<React.SetStateAction<string>>;

  isHelpPanelOpen: boolean;
  setHelpPanelOpen: React.Dispatch<React.SetStateAction<boolean>>;

  guessedWords: string[];
  setGuessesWords: React.Dispatch<React.SetStateAction<string[]>>;

  isGameStarted: boolean;
  setGameStarted: React.Dispatch<React.SetStateAction<boolean>>;
  time: number;
  setTime: React.Dispatch<React.SetStateAction<number>>;

  isTimerRunning: boolean;
  setIsTimerRunning: React.Dispatch<React.SetStateAction<boolean>>;
};

const GameContext = createContext<GameContextType | undefined>(undefined);

export const GameProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [message, setMessage] = useState<string>(MESSAGES.FIRST_START);
  const [isHelpPanelOpen, setHelpPanelOpen] = useState<boolean>(false);
  const [guessedWords, setGuessesWords] = useState<string[]>([]);
  const [isGameStarted, setGameStarted] = useState<boolean>(false); //запущена ли игра
  const [time, setTime] = useState(0); // время в секундах
  const [isTimerRunning, setIsTimerRunning] = useState(false); // запущен ли таймер
  
  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isTimerRunning) {
      interval = setInterval(() => {
        setTime((t) => t + 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [isTimerRunning]);

  return (
    <GameContext.Provider
      value={{
        message,
        setMessage,
        isHelpPanelOpen,
        setHelpPanelOpen,
        guessedWords,
        setGuessesWords,
        time,
        setTime,
        isTimerRunning,
        setIsTimerRunning,
        isGameStarted,
        setGameStarted,
      }}
    >
      {children}
    </GameContext.Provider>
  );
};

export const useGame = () => {
  const context = useContext(GameContext);
  if (!context) {
    throw new Error("useGame must be used within a GameProvider");
  }
  return context;
};
